var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23669 7.10677L12.8705 1.38184L15.5927 12.5546L3.76803 13.3856L2.23669 7.10677Z",
    fill: "#E95B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0248534 8.30691C-0.230356 7.1065 1.55615 6.55247 1.89638 7.84521L3.08734 13.0162C3.42759 14.2166 1.64117 14.7706 1.30086 13.4779L0.0248534 8.30691Z",
    fill: "#E95B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3809 1.28978C13.0406 -0.00293567 14.8271 -0.556942 15.1674 0.735775L17.8896 11.9086C18.2298 13.2013 16.4434 13.663 16.1031 12.4626L13.3809 1.28978Z",
    fill: "#E95B2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17077 13.5704V14.3091C7.17077 14.4938 7.34093 14.5861 7.51103 14.5861L10.9137 14.4938C11.0839 14.4938 11.254 14.3091 11.254 14.1245L11.169 13.2935L12.3599 13.2012V14.0322C12.445 14.9556 11.7644 15.6943 10.9988 15.6943L7.59607 15.879C6.74534 15.879 6.06478 15.2326 6.06478 14.3093L5.97974 13.6629L7.1707 13.5706L7.17077 13.5704Z",
    fill: "#E95B2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.186 6.36808C19.4204 6.55278 19.0801 5.26007 19.8458 5.07536L23.0784 4.15195C23.9291 3.87493 24.1843 5.16767 23.4186 5.44467L20.186 6.36808Z",
    fill: "#E95B2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1656 3.78292C18.5701 4.33693 17.8045 3.32122 18.4 2.76719L20.9521 0.366379C21.6327 -0.187626 22.3983 0.828076 21.8028 1.3821L19.1658 3.78292H19.1656Z",
    fill: "#E95B2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.186 7.84604C19.4204 7.66134 19.1652 9.04644 20.0158 9.13875L23.3336 9.78515C24.0992 9.96985 24.2694 8.67714 23.5038 8.49244L20.186 7.84604Z",
    fill: "#E95B2E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/Attention.bb2bbf86bc1795d4c6005dcccc9a2865.svg";
export { ForwardRef as ReactComponent };